import { defineAsyncComponent } from '../../../../lib/utils/vue3compat/vue.js?vue3';
import { uniqueId } from 'lodash-es';
import { GlTooltipDirective, GlButton, GlIcon, GlLink, GlTruncate } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { sprintf, __ } from '~/locale';
import defaultAvatarUrl from 'images/no_avatar.png';
import { getIdFromGraphQLId } from '~/graphql_shared/utils';
import TimeagoTooltip from '../../../../vue_shared/components/time_ago_tooltip.vue?vue3';
import UserAvatarImage from '../../../../vue_shared/components/user_avatar/user_avatar_image.vue?vue3';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import CommitPopover from '../../../../vue_shared/components/commit_popover.vue?vue3';
import { getAgentSessionUrls } from '../utils';
export default {
    name: 'BlameCommitInfo',
    components: {
        GlButton,
        GlIcon,
        GlLink,
        GlTruncate,
        TimeagoTooltip,
        UserAvatarImage,
        CommitPopover,
        AgentSessionLink: defineAsyncComponent(()=>import('../../../../../../../ee/app/assets/javascripts/blob/components/agent_session_link.vue?vue3')),
        AgentSessionPopover: defineAsyncComponent(()=>import('../../../../../../../ee/app/assets/javascripts/blob/components/agent_session_popover.vue?vue3'))
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    props: {
        commit: {
            type: Object,
            required: true
        },
        previousBlamePath: {
            type: String,
            required: false,
            default: null
        }
    },
    data () {
        return {
            popoverTargetId: uniqueId('blame-commit-popover-')
        };
    },
    computed: {
        commitTitle () {
            return this.commit.title || '';
        },
        avatarLinkAltText () {
            return sprintf(__(`%{username}'s avatar`), {
                username: this.commit.authorName
            });
        },
        avatarUrl () {
            return this.commit.authorGravatar || this.commit.avatarUrl || this.$options.defaultAvatarUrl;
        },
        commitUrl () {
            return this.commit.webPath || this.commit.commitUrl;
        },
        hasMessage () {
            return Boolean(this.commit.message || this.commit.title);
        },
        agentSessionUrls () {
            if (!this.glFeatures.blameAgentSessions) return [];
            return getAgentSessionUrls(this.commit);
        },
        author () {
            return this.commit.author;
        },
        authorUserId () {
            return this.author?.id ? getIdFromGraphQLId(this.author.id) : null;
        },
        authorUsername () {
            return this.author?.username || '';
        },
        authorWebPath () {
            return this.author?.webPath || '';
        },
        avatarWrapperProps () {
            if (!this.author) return {};
            return {
                href: this.authorWebPath,
                'data-user-id': this.authorUserId,
                'data-username': this.authorUsername,
                class: 'js-user-link',
                'data-testid': 'commit-author-link'
            };
        }
    },
    defaultAvatarUrl,
    i18n: {
        viewBlamePrior: __('View blame prior to this change')
    }
};
